module.exports = __webpack_public_path__ + "static/media/main idea.a99cddb8.mp3";